import {Response} from './Response.js';

export type HttpMethods = 'get' | 'post' | 'put' | 'delete' | 'patch';
export enum ResponseType {
  JSON,
  STREAM,
}

export interface RequestOptions<RequestPayload, QueryParams> {
  method: HttpMethods;
  url: string;
  queryParams?: QueryParams;
  headers?: Record<string, string>;
  body?: RequestPayload;
  responseType?: ResponseType;
  withCredentials?: boolean;
}

export interface HttpClient {
  get<ResponsePayload>(url: string): Promise<Response<ResponsePayload>>;
  post<RequestPayload, ResponsePayload>(
    url: string,
    body?: RequestPayload
  ): Promise<Response<ResponsePayload>>;
  put<RequestPayload, ResponsePayload>(
    url: string,
    body?: RequestPayload
  ): Promise<Response<ResponsePayload>>;
  delete<RequestPayload, ResponsePayload>(
    url: string,
    body?: RequestPayload
  ): Promise<Response<ResponsePayload>>;
  patch<RequestPayload, ResponsePayload>(
    url: string,
    body?: RequestPayload
  ): Promise<Response<ResponsePayload>>;

  request<RequestPayload, ResponsePayload, QueryParams>(
    requestOptions: RequestOptions<RequestPayload, QueryParams>
  ): Promise<Response<ResponsePayload>>;
  setAuthToken(token: string): void;
  clearAuthToken(): void;
}
